export default __webpack_public_path__ + "22e46caac6ca7a05d9dd9492ed0a1878.png";